// extracted by mini-css-extract-plugin
export var errorIcon = "_r1-1";
export var nameLogo = "_r1-0";